function updateSellingPlan(e) {
  let selectElement = e.target;
  let subscriptionId = selectElement.value;
  let itemQtn = selectElement.getAttribute("data-item-quantity");
  let itemId = selectElement.getAttribute("data-item-id");
  let itemKey = selectElement.getAttribute("data-item-key");

  // if (subscriptionId) {
  console.log(subscriptionId, itemQtn, itemId, itemKey);

  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      id: itemKey,
      quantity: itemQtn,
      selling_plan: subscriptionId,
    }),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      console.log("Subscription added to cart:");
      updateCart("/cart?section_id=cart-drawer");
      if (location.href.includes("/cart")) {
        const cartPage = document.querySelector("cart-items").id;
        updateCart(`/cart?section_id=${cartPage}`);
      }
    })
    .catch((error) => {
      console.error("Error adding subscription:", error);
    });
  // }
}

function updateCart(url) {
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      // console.log(html);

      const selectors = [
        "cart-drawer-items",
        ".cart-drawer__footer",
        "cart-items",
        ".cart__footer ",
      ];

      selectors.forEach((selector, index) => {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        // console.log("Source ELEMENT : ", index, sourceElement);
        // console.log("Target ELEMENT : ", index, targetElement);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      });
    })
    .catch((error) => {
      console.log("Error updating Cart", error);
    });
}

// <!-- CLEAR CART ON SUCCESSFUL ACCOUNT LOGIN -->
const urlParams = new URLSearchParams(window.location.search);
const loginSuccess = urlParams.get("login_success");

if (loginSuccess) {
  console.log("Login was successful!");

  fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (response.ok) {
        const newUrl = window.location.origin + window.location.pathname;
        // Replace the URL
        window.history.replaceState({}, document.title, newUrl);

        // Reload the page to show empty cart
        // window.location.reload();
        updateCart("/cart?section_id=cart-drawer");
        document.querySelector(".cart-count-bubble span").innerHTML = "0";
      } else {
        console.error("Error clearing cart:", response.statusText);
      }
    })
    .catch((error) => {
      console.error("Error clearing cart:", error);
    });
}
